import { ICommunityResource } from '@/types/admin/resources';

export const adjustForEmptySlots = (
  sortedResults: ICommunityResource[],
  availablePositions: number[],
): ICommunityResource[] => {
  const availableResults = sortedResults.filter((resource: ICommunityResource) =>
    availablePositions.includes(resource.position),
  );

  const gapPositions = availablePositions.filter((pos: number, index: number) => {
    const isOccupied = Boolean(
      availableResults.find((resource: ICommunityResource) => resource.position === pos),
    );
    if (isOccupied) {
      return false;
    }
    return availablePositions.slice(index + 1).find((secondPos) => {
      return Boolean(
        availableResults.find((resource: ICommunityResource) => resource.position === secondPos),
      );
    });
  });

  if (!gapPositions.length) {
    return availableResults;
  }

  return availableResults.map((resource: ICommunityResource) => {
    if (resource.position > gapPositions[0]) {
      return { ...resource, position: resource.position - gapPositions.length };
    }
    return resource;
  });
};


